import { styled } from "styled-components";

export const AvatarContainer = styled.div<AvatarContainerProps>(
  ({ theme, $size }) => {
    const styles = {
      flexShrink: 0,
      borderRadius: theme.radii.round,
      backgroundColor: theme.colors.grayLight,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
    };

    const small = {
      height: theme.sizes.xs,
      width: theme.sizes.xs,
    };

    const large = {
      height: theme.sizes.xxl,
      width: theme.sizes.xxl,
      boxSizing: "border-box",
      boxShadow: `0 4px 16px 0 ${theme.shadows[4]}, 0 0 0 1px ${theme.shadows[2]}`,
    };

    return {
      ...styles,
      ...($size === "small" ? small : large),
    };
  },
);

export type AvatarContainerProps = {
  $size: "small" | "large";
};
